<div class="pageContent">
  @if (showAdvice) {
    <mat-card class='mat-card-text'>
      Para que los cambios tengan efecto debes volver a iniciar sesión. <button mat-raised-button class='cerrarSesionButton' (click)='logout()'>Cerrar sesión</button>
    </mat-card>
  }

  <mat-card class='mat-card'>

    <div class="left">
      <img src="{{userProfileImageSRC}}" alt="user_profile_photo" title="user_profile_photo" class='userProfileIMG'>
      <p class='userName'>{{name}} {{surname}}</p>
      <p class='userEmail'>{{email}}</p>
    </div>

    <div class="right">
      <mat-tab-group class="profileTabs" dynamicHeight animationDuration="0ms">
        <mat-tab label="Datos">
          <form [formGroup]="datosForm">
            <mat-form-field class='formField'>
              <mat-label>Nombre</mat-label>
              <input matInput placeholder="Nombre" formControlName="name" [(value)]="name" required>
            </mat-form-field>
            <mat-form-field class='formField'>
              <mat-label>Apellidos</mat-label>
              <input matInput placeholder="Apellidos" formControlName="surname" [(value)]="surname" required>
            </mat-form-field>
            <mat-form-field class='formField'>
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" formControlName="email" [(value)]="email" required>
            </mat-form-field>
          </form>
          <div class="buttonFooter">
            <button mat-raised-button color="primary" (click)="saveUserData()">Guardar</button>
          </div>
        </mat-tab>
        <mat-tab label="Contraseña">
          <form [formGroup]="passwordForm">
            <mat-form-field class='formField'>
              <mat-label>Contraseña</mat-label>
              <input matInput placeholder="Contraseña" formControlName="password" [(value)]="password" required>
            </mat-form-field>
            <p class='mini'>* Debe tener mínimo 8 caracteres.</p>
          </form>
          <div class="buttonFooter">
            <button mat-raised-button color="primary" (click)="saveUserPassword()">Guardar</button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-card>
</div>
